import { gql } from '@apollo/client';
import { ErrorMessageInfo } from '@retainerclub/shared-api';

export default gql`
  mutation actionAnalyzeLegacyAccount($input: AnalyzeLegacyAccountInput!) {
    actionAnalyzeLegacyAccount(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      success
      analysisData
    }
  }
  ${ErrorMessageInfo}
`;
